// extracted by mini-css-extract-plugin
export default {"input":"SearchBar_input__2Stz6","toggle":"SearchBar_toggle__dRrUY","toggleOption":"SearchBar_toggleOption__-QOK+"};